module.exports = __webpack_public_path__ + "img/check_gray.ec537f61.png";